import {
  Component,
  OnChanges,
  Input,
  Output,
  SimpleChanges,
  EventEmitter
} from "@angular/core";
import { LegendItem } from "app/shared/data-interaction";

@Component({
  selector: "app-chart-legend",
  templateUrl: "./chart-legend.component.html",
  styleUrls: ["./chart-legend.component.css"]
})
export class ChartLegendComponent implements OnChanges {
  @Input() clickable = false;
  @Input() desiredLegendItems: LegendItem[];
  @Output() legendClick = new EventEmitter<number>();
  private localLegendItems: LegendItem[] = [];

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.desiredLegendItems && changes.desiredLegendItems.currentValue) {
      // update local copy of legend items
      this.localLegendItems = this.desiredLegendItems;
    }
  }

  /*
  Emit index of the legend clicked to the parent if clickable is enabled
  */
  onLegendClick(legendIndex: number) {
    if (this.clickable) {
      this.localLegendItems[legendIndex].clicked = !this.localLegendItems[
        legendIndex
      ].clicked;
      this.legendClick.emit(legendIndex);
    }
  }
}
